"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./CardShell.scss");
var key_press_1 = require("../../../utils/key-press");
var CardShell = function (_a) {
    var ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className, classNameElement = _a.classNameElement, classNamePad = _a.classNamePad, href = _a.href, isChecked = _a.isChecked, noPad = _a.noPad, onClick = _a.onClick, onDark = _a.onDark, tabIndex = _a.tabIndex, _b = _a.target, target = _b === void 0 ? "self" : _b, testId = _a.testId, _c = _a.type, type = _c === void 0 ? "default" : _c, withMobileBleed = _a.withMobileBleed, withSelectedBg = _a.withSelectedBg;
    var _d = __read(React.useState({
        checked: isChecked ? isChecked : false,
        showFocus: false,
    }), 2), state = _d[0], setState = _d[1];
    var checked = state.checked, showFocus = state.showFocus;
    var onFocus = function () {
        setState(__assign(__assign({}, state), { showFocus: false }));
    };
    var onKeyDown = function (e) {
        if ((key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) && type !== "default") {
            e.preventDefault();
        }
    };
    var onKeyUp = function (e) {
        if ((key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e) || key_press_1.KeyPress.tabIsPressed(e)) && type !== "default") {
            setState(__assign(__assign({}, state), { showFocus: true }));
        }
        if ((key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) && type !== "default") {
            e.preventDefault();
            if ((type === "radio" || type === "checkbox") && isChecked === undefined) {
                setState(__assign(__assign({}, state), { checked: type === "checkbox" ? !checked : true }));
            }
            if (type === "link" && href) {
                if (target === "blank") {
                    window.open(href, "_blank");
                }
                else {
                    window.open(href, "_self");
                }
            }
            if (onClick) {
                if (e.target instanceof HTMLAnchorElement) {
                    e.preventDefault();
                }
                else {
                    onClick(type === "radio" || type === "checkbox"
                        ? isChecked !== undefined
                            ? isChecked
                            : checked
                        : undefined);
                }
            }
        }
    };
    var onMouseDown = function (e) {
        setState(__assign(__assign({}, state), { showFocus: false }));
        if (e.button === 0) {
            if ((type === "radio" || type === "checkbox") && isChecked === undefined) {
                setState(__assign(__assign({}, state), { checked: !checked }));
            }
            if (type === "link" && href) {
                if (target === "blank") {
                    window.open(href, "_blank");
                }
                else {
                    window.open(href, "_self");
                }
            }
            if (onClick && type !== "default") {
                if (e.target instanceof HTMLAnchorElement) {
                    e.preventDefault();
                }
                else {
                    onClick(type === "radio" || type === "checkbox"
                        ? isChecked !== undefined
                            ? isChecked
                            : checked
                        : undefined);
                }
            }
        }
    };
    var onMouseUp = function () {
        setState(__assign(__assign({}, state), { showFocus: false }));
    };
    var renderChildren = function () { return React.Children.map(children, function (child) { return child; }); };
    var Element = type === "link" ? "a" : "div";
    var innerContent = (React.createElement(Element, { "aria-checked": type === "checkbox" || type === "radio"
            ? isChecked === true || (isChecked === undefined && checked)
            : undefined, className: "card height-full inline-block radius-xs rel width-full " + styles.card + " " + (onDark ? " bg-ui-white" : "") + ((type === "radio" || type === "checkbox") &&
            (isChecked === true || (isChecked === undefined && checked))
            ? " " + styles.selected + " selected" + (withSelectedBg ? " " + styles.willRemoveBgCobalt10 : "")
            : "") + (withMobileBleed ? " " + styles.cardNoBorderRadius : "") + (classNameElement ? " " + classNameElement : ""), "aria-label": ariaLabel ? ariaLabel : undefined, "data-focus-method": showFocus ? "KEY" : undefined, "data-is-link": type === "link", "data-testid": testId, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseUp: onMouseUp, tabIndex: type !== "default" ? 0 : tabIndex ? tabIndex : undefined, role: type !== "default" && type !== "link" ? type : undefined },
        React.createElement("div", { className: styles.cardPad + " card-pad flex flex-column height-full " + (noPad ? " pad-none" : "") + " " + (classNamePad ? " " + classNamePad : "") }, renderChildren())));
    if (className) {
        return React.createElement("div", { className: className }, innerContent);
    }
    return innerContent;
};
exports.default = CardShell;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CardShell/CardShell.js
// module id = 1753
// module chunks = 8